export const uniqueSheetName = (title, names) => {
  const base = title.replace(/[\\/?*\[\]:\x00-\x1f]/g, ' ').replace(/^'+|'+$/g, '').trim() || 'Section';
  let name = base.slice(0, 31).replace(/'+$/g, '');
  let suffix = 1;
  while (names.some(existing => existing.toLowerCase() === name.toLowerCase())) {
    const ending = ` (${++suffix})`;
    name = `${base.slice(0, 31 - ending.length)}${ending}`;
  }
  return name;
};

export const buildVisibleWorkbook = (XLSX, snapshot) => {
  const workbook = XLSX.utils.book_new();
  const append = (title, rows) => {
    // Literal strings preserve displayed precision, dates, Unicode and leading zeros.
    // No formulas, hyperlinks, raw API records or reconstructed forecasts are added.
    const sheet = XLSX.utils.aoa_to_sheet(rows.map(row => row.map(value => String(value ?? ''))));
    const width = Math.max(0, ...rows.map(row => row.length));
    sheet['!cols'] = Array.from({ length: width }, (_, i) => ({
      wch: Math.min(65, Math.max(12, ...rows.map(row => String(row[i] ?? '').length + 2))),
    }));
    XLSX.utils.book_append_sheet(workbook, sheet, uniqueSheetName(title, workbook.SheetNames));
  };
  append('Export Info', [
    ['Window', 'W37 — Yoga Poses'],
    ['View', snapshot.view === 'summary' ? 'Pose Summary' : 'Pose Details'],
    ['Scope', 'Rows visible on screen at download click; partially visible rows included.'],
    ['Excluded', 'Off-screen, scroll-clipped, hidden and inactive-tab rows.'],
    ['Source draw', snapshot.sourceDraw ?? 'Unavailable'],
    ['Source date', snapshot.sourceDate ?? 'Unavailable'],
    ['Captured at (UTC)', snapshot.capturedAt],
    ['Data status', snapshot.stale ? 'Last available data — refresh failed' : 'Displayed data'],
    ['Visible rows', snapshot.sections.reduce((sum, section) => sum + section.rows.length, 0)],
  ]);
  snapshot.sections.forEach(section => {
    append(section.name, [[section.name], [], section.columns, ...section.rows]);
  });
  return workbook;
};

export const visibleExportFilename = snapshot => {
  const view = snapshot.view === 'summary' ? 'Pose_Summary' : 'Pose_Details';
  const draw = String(snapshot.sourceDraw ?? 'unavailable').replace(/[^a-zA-Z0-9_-]/g, '_');
  return `W37_${view}_visible_draw_${draw}_${snapshot.capturedAt.replace(/[:.]/g, '-')}.xlsx`;
};
